module.exports = "<div class=\"printerWrapper\">\n<div class=\"container-fluid\">\n  <div class=\"row justify-content-center mt-5\">\n    <div class=\"col-sm-8 col-lg-4\">\n      <div class=\"card card-outline-warning\">\n        <div class=\"card-header\">\n          <h2>Select a Printer Location</h2>\n          <hr />\n          <button class=\"btn btn-block btn-lg btn-warning\" *ngFor=\"let p of printers\" (click)=\"setPrinter(p)\">\n            {{p}} <i class=\"fa fa-print\"></i>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/printer.component.html
// module id = 466
// module chunks = 0